<script setup lang="ts">
const imagePaths = [
  [
    '/static-assets/card-bg/4-5/book.webp',
    '/static-assets/card-bg/1-1/01.webp',
    '/static-assets/card-bg/3-5/cover.webp',
    '/static-assets/card-bg/9-16/art.webp',
    '/static-assets/card-bg/1-1/02.webp',
  ],
  [
    '/static-assets/card-bg/1-1/03.webp',
    '/static-assets/card-bg/4-5/concert.webp',
    '/static-assets/card-bg/9-16/fashion.webp',
    '/static-assets/card-bg/1-1/04.webp',
    '/static-assets/card-bg/4-5/music.webp',
  ],
  [
    '/static-assets/card-bg/3-5/cover02.webp',
    '/static-assets/card-bg/4-5/art.webp',
    '/static-assets/card-bg/1-1/ablum03.webp',
    '/static-assets/card-bg/9-16/compaign.webp',
    '/static-assets/card-bg/4-5/book02.webp',
  ],
  [
    '/static-assets/card-bg/4-5/event02.webp',
    '/static-assets/card-bg/9-16/nike1.webp',
    '/static-assets/card-bg/3-5/03.webp',
    '/static-assets/card-bg/4-5/01.webp',
    '/static-assets/card-bg/1-1/album05.webp',
  ],
  [
    '/static-assets/card-bg/9-16/compaign02.webp',
    '/static-assets/card-bg/3-5/01.webp',
    '/static-assets/card-bg/4-5/event.webp',
    '/static-assets/card-bg/1-1/album04.webp',
    '/static-assets/card-bg/3-5/new01.webp',
  ],
  [
    '/static-assets/card-bg/3-5/04.webp',
    '/static-assets/card-bg/9-16/nike2.webp',
    '/static-assets/card-bg/4-5/02.webp',
    '/static-assets/card-bg/3-5/cover03.webp',
    '/static-assets/card-bg/9-16/Poster.webp',
  ],
].map((column) => column.map((src) => `https://static.veeso.ai${src}`));

const galleryColumns = imagePaths.map((column) =>
  column.map((src) => ({
    src,
    opacity: 0.3 + Math.random() * 0.5,
    scale: 0.3 + Math.random() * 0.5,
  }))
);
</script>

<template>
  <div class="min-h-screen relative flex flex-col auth-bg">
    <!-- Background Image Gallery - Full Screen -->
    <div class="absolute inset-0 overflow-hidden">
      <div class="absolute inset-0 flex gap-4 px-4">
        <div
          v-for="(column, colIndex) in galleryColumns.slice(0, 6)"
          :key="colIndex"
          class="flex-1 overflow-hidden"
          :class="colIndex >= 3 ? 'hidden md:block' : ''"
        >
          <div
            class="flex flex-col gap-2"
            :class="colIndex % 2 === 0 ? 'animate-scroll-up' : 'animate-scroll-down'"
          >
            <template v-for="repeat in 3" :key="repeat">
              <div
                v-for="(img, imgIndex) in column"
                :key="`${repeat}-${imgIndex}`"
                class="overflow-hidden rounded-lg flex-shrink-0"
              >
                <img
                  :src="img.src"
                  alt="Design example"
                  class="w-full h-auto object-cover"
                  :style="{
                    opacity: img.opacity,
                    transform: `scale(${img.scale})`,
                  }"
                  loading="lazy"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Slot -->
    <slot />
  </div>
</template>

<style scoped>
.auth-bg {
  background: linear-gradient(
    to bottom,
    #94b3da 0%,
    #d0e3f6 15%,
    #f5f1e6 30%,
    #e8d5c3 45%,
    #97a4bc 60%,
    #395e94 75%,
    #08306f 90%,
    #02245d 100%
  );
}

/* Auto-scrolling animation */
@keyframes scroll-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

@keyframes scroll-down {
  0% {
    transform: translateY(-50%);
  }
  100% {
    transform: translateY(0);
  }
}

.animate-scroll-up {
  animation: scroll-up 800s linear infinite;
}

.animate-scroll-down {
  animation: scroll-down 800s linear infinite;
}
</style>
